import { type Employees } from 'modules/employees/store/collections/employees'

import { type Memberships } from './collections/memberships'
import { membershipEmployee } from './membershipEmployee'

export const teamMemberships = (memberships: Memberships, employees: Employees, teamId: number) => {
  return memberships.filter(
    (membership) =>
      !membershipEmployee(employees, membership).isTerminated &&
      membership.attributes.team_id === teamId
  )
}
